import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import React from 'react';
import { ExposureConfigurationResponse } from '../../../api/ConfigApi';
import { AuthData } from '../../../context/auth';
import { PolicyData, withPolicyContext } from '../../../context/policy';
import { Exposure, ExposureCharacteristics } from '../../../types/policy';
import Peril from './Peril';
import ReviewChangesField from './ReviewChangesField';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
	characteristicTimestamp: string;
	referenceTimestamp: string;
	exposure: Exposure;
	exposureCharacteristic: ExposureCharacteristics;
	exposureConfiguration: ExposureConfigurationResponse;
}

const EndedExposureDetails = (props: Props) => {
	const {
		characteristicTimestamp,
		referenceTimestamp,
		exposure,
		exposureCharacteristic,
		exposureConfiguration,
	} = props;

	const renderFields = () => {
		return exposureConfiguration.fields.map((field, ind) => {
			const value = exposureCharacteristic.fieldValues[field.name] || '';
			return (
				<ReviewChangesField
					key={`${field}-${ind}`}
					field={field}
					value={value}
					fieldGroupsByLocator={null}
					allValues={exposureCharacteristic.fieldValues}
					currentFieldValues={exposureCharacteristic.fieldValues}
					addFieldGroups={null}
				/>
			);
		});
	};

	const renderPerils = () => {
		if (!exposure.perils.length) {
			return null;
		}
		return exposure.perils.map((p) => (
			<Peril
				key={p.locator}
				peril={p}
				characteristicTimestamp={characteristicTimestamp}
				referenceTimestamp={referenceTimestamp}
				exposureConfiguration={exposureConfiguration}
			/>
		));
	};

	const exposureName = exposureConfiguration.displayName
		? exposureConfiguration.displayName
		: exposure.name;
	return (
		<Accordion>
			<AccordionSummary
				style={{ borderBottom: '1px solid rgba(0, 0, 0, .125)' }}
				expandIcon={<ExpandMoreIcon />}
			>{`Ended: ${exposureName} ${exposure.displayId}`}</AccordionSummary>
			<AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ marginTop: '10px ', marginBottom: '10px' }}>
					{renderFields()}
				</div>
				{renderPerils()}
			</AccordionDetails>
		</Accordion>
	);
};

export default withPolicyContext<Props>(EndedExposureDetails);
